import * as $ from 'jquery';
import * as kendo from 'kendo';
import * as publisher from 'publisher';
import Popup, { IPopupShowOptions, IPopupOpenPageOptions, getParamStr } from 'CMS/UI/Popup';
import * as app from 'CMS/core/application';
import * as conf from 'CMS/conf';



function getMyPopupTopic() {
    if (window != window.top) {
        var _i = $(parent.document).find("iframe[name='" + window.name + "']");
        return _i.attr("topic");
    } else { return null; }
}

export function showSelector<T>(options: IPopupShowOptions): Promise<T> {    
    return new Promise((resolve, reject) => {
        /* Add close handler */
        const close = options.close;
        if (close != null) {
            options.close = (e) => {
                /* Call original handler first */
                close(e);

                /* Complete promise */
                if (e == null || e.cancelled === true) {
                    reject();
                } else {
                    resolve(<T>e.data);
                }
            }
        } else {
            options.close = (e) => {
                /* Complete promise */
                if (e == null || e.cancelled === true) {
                    reject();
                } else {
                    resolve(<T>e.data);
                }
            };
        }

        /* Show popup */
        show(options);        
    });
}


export function show(options: IPopupShowOptions):string {
    var p = new Popup();
    p.show(options);
    return p.topic;
}
export function showError(errorMessage: string, title?: string) {
    var p = new Popup();
    p.showError(errorMessage, title);
    return p.topic;    
}
export function showWarning(message: string, title?: string) {
    var p = new Popup();
    p.showWarning(message, title);
    return p.topic;
}

export function openPage(options: IPopupOpenPageOptions) {
    var _url: string;
    if (options.url != null) {
        _url = options.url;
    } else {
        _url = 'default.aspx?';
        var _params = getParamStr(options.params);

        if (options.page != null) {
            _url += 'path=' + options.page + "&" + _params;
        } else if (options.pageID != null) {
            _url += 'pageID=' + options.pageID + "&" + _params;
        }
    }

    if (options.target == null) {
        window.location.href = _url;
    } else {
        window.open(_url, options.target);
    }
}

/**
 * INTERNAL USE: Detect if the current page is inside a popup and initialize all necessary handlers. Initialize listening on window for message from child windows (popups).
 */
export function popupDetection() {
    if (window != window.top) {
        $('#pdetect').val(getMyPopupTopic());

        /* Page is inside an iframe (popup) */
        var pageImport = import('CMS/core/page');
        pageImport.then((page) => {
            page.initializePopupSubscription();

            messageToParent("AWF.PageInitialized");
        });        
    }

    window.onmessage = (e: any) => {
        if (e != null && e.data.type === 'awf.topublish' && e.data != null && e.data.topic != null) {
            var jsonData = e.data.data;
            var data = null;
            if (jsonData != null && jsonData != "") {
                data = JSON.parse(jsonData); /* argument array */
            }

            var publishArgs = [];
            publishArgs.push(e.data.topic);

            /* Optional arguments */
            if (e.data.action != null) {
                publishArgs.push(e.data.action);
            }

            if (data != null && data.length && data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    publishArgs.push(data[i]);
                }
            }
            publisher.publish.apply(publisher, publishArgs);

        }
    };
}

/**
 * DEPRECATED: use messageToParent instead
 * @param action
 */
export function msgToParent(action: string, ...data: any[]) {
    //DEPRECATED: use messageToParent instead
    messageToParent(action, data);    
}


export function messageToParent(action: 'close', data?: any): void;
export function messageToParent(action: 'maximize'): void;
export function messageToParent(action: 'resize'): void;
export function messageToParent(action: 'restore'): void;
export function messageToParent(action: string, ...data: any[]): void;
/**
 * Send an action to the popup
 * @param action
 * @param data
 */
export function messageToParent(action: string, ...data: any[]): void {    
    window.top.postMessage({
        type: 'awf.topublish',
        action: action,
        topic: $('#pdetect').val(),
        data: JSON.stringify(data)
    }, '*');
}


/**
 * Publish a message on the parents publisher
 * @param topic
 * @param data
 */
export function publishToParent(topic: string, ...data: any[]) {
    if (arguments.length > 0) {        
        window.top.postMessage({
            type: 'awf.topublish',
            topic: topic,
            data: JSON.stringify(data)
        }, '*');
    }
}



